export const UserProfile = {
  Admin: 1,
  Director: 2,
  UEBDirector: 3,
  Guide: 4,
  QualitySpecialist: 5,
  OperationManager: 6,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.blueolympic';
export const isDarkSwitchActive = false;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic', //
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby', //
  'yellowgranola', //
  'greysteel',
];

export const pageSizeOptions = [5, 10, 25, 50];

export const EMPTY_HTML_EDITOR_VALUE = '<p><br></p>';

export const IMAGES_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const FILTER_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  DATETIME: 'datetime',
  TIME: 'time',
  SELECT: 'select',
};